import { CommonModule } from "@angular/common";

import { Component, inject, resource } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { environment } from "../../environments/environment";
import { WarehouseService } from "../_services";
import { RouterModule } from "@angular/router";

@Component({
  imports: [CommonModule, RouterModule],
  selector: "hawk-warehouse-bulk-list",
  templateUrl: "./warehouse-bulk-list.component.html",
  styleUrls: ["./warehouse-bulk-list.component.scss"],
  host: {
    class: "app-page",
  },
})
export class WarehouseBulkListComponent {
  private service = inject(WarehouseService);
  protected resource = resource({
    loader: () => firstValueFrom(this.service.loadBulkJobs()),
  });

  protected getUrl(id: number): string {
    return environment.apiURL + "bulk_rma/" + id + ".pdf";
  }
}
